// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FIpdx","controls":"styles_controls__gz6eo","charLimit":"styles_charLimit__2NQ21","input":"styles_input__2xKVo","send":"styles_send__2QYGb"};